import { Data, DateUtils, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../../DomainTypes';
import Holiday from '../../Models/Catalogue/General/Holiday';
import { BusinessDayConvention } from '../../Models/Dividends/BusinessDayConvention.enum';

export interface IGeneralApiClient {

    getHolidaysForYear(year: number): AxiosPromise<Array<Model.PlainTrackedObject<Holiday>>>;

    saveHolidays(holidays: Array<Model.PartialPlainObject<Holiday>>): AxiosPromise<Array<Model.PlainTrackedObject<Holiday>>>;

    /** 
     * Calculates the next (or previous) business day based on the given reference date taking holidays into account.
     */
    calculateBusinessDayAsync(referenceDate: Date, businessDayConvention: BusinessDayConvention, dateOffset: number): Promise<Date>;

    // Client only properties / methods
}

@injectable()
export default class GeneralApiClient extends Data.ApiClientBase implements IGeneralApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/catalogue/general`);
    }

    public getHolidaysForYear(year: number): AxiosPromise<Array<Model.PlainTrackedObject<Holiday>>> {
        return this.axios.get(`${this.apiPath}/holidays/${year}`);
    }

    public saveHolidays(holidays: Array<Model.PartialPlainObject<Holiday>>): AxiosPromise<Array<Model.PlainTrackedObject<Holiday>>> {
        return this.axios.post(`${this.apiPath}/holidays`, holidays);
    }

    public async calculateBusinessDayAsync(referenceDate: Date, businessDayConvention: BusinessDayConvention, dateOffset: number): Promise<Date> {
        const result = await this.axios.get(`${this.apiPath}/business-day/${DateUtils.format(referenceDate, "yyyy-MM-dd")}?businessDayConvention=${businessDayConvention}&dateOffset=${dateOffset}`);
        return new Date(result.data);
    }

    // Client only properties / methods
}